<template>
    <modal size="lg" @close="$emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            Edit Deduction
        </template>
        <slot>
            <form-errors :errors="formErrors"/>

            <div class="mb-3 p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Base Deduction Type: </span>{{ deduction.deduction_type.name }}</div>
                <div><span class="text-muted">Name: </span>{{ deduction.name }}</div>
            </div>

            <form class="mui-form" @submit.prevent="onSubmit()">
                <div class="form-row" v-if="canCustomize('name')">
                    <div class="col">
                        <form-input v-model="formData.name" :errors="errors.name" type="text" label="Name" />
                    </div>
                </div>

                <div class="form-row mb-2" v-if="canCustomize('for_primary_benefit_of_employer')">
                    <div class="col">
                        <form-input v-model="formData.for_primary_benefit_of_employer" :errors="errors.for_primary_benefit_of_employer" type="checkbox" label="For Primary Benefit of Employer" />
                    </div>
                </div>
            </form>
        </slot>

        <template v-slot:footer>
            <button-row>
                <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                <button type="button" class="btn btn-block btn-primary" @click.prevent="onSubmit()">Save</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['deduction', 'client'],
    mixins: [FormMixin, ModalMixin],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    methods: {
        canCustomize(fieldName) {
            return this.deduction?.deduction_type?.fields_to_customize?.includes(fieldName) || false
        },
        makeFormData() {
            return {
                name: this.deduction?.name || '',
                for_primary_benefit_of_employer: this.deduction?.for_primary_benefit_of_employer || false,
            }
        },
        getFormData() {
            return this.formData
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            this.errors = {}
            this.formErrors = []
            return this.$api.put(`/clients/${this.client.id}/settings/deduction-types/${this.deduction.id}`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    }
}
</script>
